module.exports = __webpack_public_path__ + "img/sm.85c8c022.png";